import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import { Outlet } from "react-router-dom";
import "./CustomerDashboard.css";

const CustomerDashboard = () => {
  return (
    <div className="dashboard-container">
      <Sidebar isCustomer={true} />
      <div className="main-content">
        <Navbar />
        <Outlet />
      </div>
    </div>
  );
};

export default CustomerDashboard;
